import Vue from 'vue'
import { camelizeKeys } from 'xcase'
import Interest from '@/models/interest'

export const state = {
  interests: [],
}

export const getters = {
  find: state => id => state.interests.find(i => i.id == id),
  findBySlug: state => slug => state.interests.find(i => i.slug == slug),
  sortBy: state => sort => {
    if (sort == 'recent') {
      return [...state.interests].sort((a, b) => b.lastLikeAt.localeCompare(a.lastLikeAt))
    } else {
      return [...state.interests].sort((a, b) => b.likesCount - a.likesCount)
    }
  },
}

export const mutations = {
  ADD(state, data) {
    const index = state.interests.findIndex(i => i.id == data.id)

    if (index == -1) state.interests.push(new Interest(data, Vue.app.user))
  },

  ADD_OR_UPDATE(state, data) {
    const interest = state.interests.find(i => i.id == data.id)

    if (interest) {
      Object.assign(interest, new Interest(data, Vue.app.user))
    } else {
      state.interests.push(new Interest(data, Vue.app.user))
    }
  },

  APPEND(state, interests) {
    interests.forEach(interest => {
      const index = state.interests.findIndex(i => i.id == interest.id)

      if (index == -1) state.interests.push(new Interest(interest, Vue.app.user))
    })
  },

  SET(state, interests) {
    state.interests = interests.map(i => new Interest(i, Vue.app.user))
  },

  UPDATE(state, data) {
    const interest = state.interests.find(i => i.id == data.id)

    if (interest) {
      Object.assign(interest, new Interest(data, Vue.app.user))
    }
  },
}

export const actions = {
  async create({ commit }, name) {
    try {
      const response = await Vue.axios.post('/interests/', {
        interest: { name: name },
      })

      commit('ADD', response.data)

      return response.data
    } catch (error) {
      console.log(error)
      Vue.notyf.error('Something went wrong. Please try again.')
    }
  },

  async fetch({ commit }, { page, sort }) {
    try {
      const response = await Vue.axios.get(`/interests?page=${page}&sort=${sort}`)

      if (page == 1) {
        commit('SET', response.data)
      } else {
        commit('APPEND', response.data)
      }

      return response
    } catch (error) {
      console.log(error)
    }
  },

  async fetchSingle({ commit }, slug) {
    try {
      const response = await Vue.axios.get(`/interests/${slug}`)

      commit('ADD_OR_UPDATE', response.data.interest)
      commit('users/SET', response.data.people, { root: true })
    } catch (error) {
      console.log(error)
    }
  },

  async search({ commit }, { query }) {
    try {
      const response = await Vue.axios.get(`/interests/search?query=${query}`)
      return response.data
    } catch (error) {
      console.log(error)
    }
  },

  async fetchPeople({ commit }, { slug, page, sort }) {
    try {
      const response = await Vue.axios.get(`/interests/${slug}/people?page=${page}&sort=${sort}`)

      if (page == 1) {
        commit('users/SET', response.data, { root: true })
      } else {
        commit('users/APPEND', response.data, { root: true })
      }
    } catch (error) {
      console.log(error)
    }
  },

  async like({ commit }, { id, page, sort }) {
    try {
      const response = await Vue.axios.post(`/interests/${id}/likes`, {
        page: page,
        sort: sort,
      })

      commit('ADD_OR_UPDATE', response.data.interest)
      commit('users/SET', response.data.users, { root: true })

      return response.data
    } catch (error) {
      console.log(error)
    }
  },

  async unlike({ commit }, id) {
    try {
      const response = await Vue.axios.delete(`/interests/${id}/likes`)
      commit('ADD_OR_UPDATE', response.data.interest)
      commit('users/SET', response.data.users, { root: true })
    } catch (error) {
      throw error
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
